import { LStorage } from "store/config/constants";

export const clearAuthData = () => {
  localStorage.removeItem(LStorage.AUTH);
  localStorage.removeItem(LStorage.REFRESH_TOKEN);
  localStorage.removeItem(LStorage.EXPIRATION_DATE);
  localStorage.removeItem(LStorage.EXPIRATION_HOURS);
};

interface IAuthData {
  accessToken: string;
  refreshToken: string;
  expireHours: number;
  expires: string;
}

export const setAuthData = (data: IAuthData) => {
  localStorage.setItem(LStorage.AUTH, data.accessToken);
  localStorage.setItem(LStorage.REFRESH_TOKEN, data.refreshToken);
  localStorage.setItem(LStorage.EXPIRATION_DATE, data.expires);
  localStorage.setItem(LStorage.EXPIRATION_HOURS, data.expireHours.toString());
};
